module.exports = __webpack_public_path__ + "static/lineBG-10578d7be0fbb8cbc3b85ee3b36cefe3.png";